import Vue from 'vue'
import Router from 'vue-router'
import header from '@/components/header'

Vue.use(Router)
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
}
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
}
export default new Router({
  routes: [{
      path: '/',
      name: 'header',
      component: header,
      redirect: (to) => {
        return {
          name: 'index'
        }
      },
      children: [

      ]
    },
    {
      path: '/index',
      name: 'index',
      component: header,
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/index/index'))),
    },
    {
      path: '/news',
      name: 'news',
      component: header,
      meta: {
        auth: ['log.query'],
        keepAlive: true
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/news/news'))),
    },
    {
      path: '/news-detail/:id',
      name: 'news-detail',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/news/news-detail'))),
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/Login/login'))),
    },
    {
      path: '/controlLogin',
      name: 'controlLogin',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/controlLogin/controlLogin'))),
    },
    {
      path: '/test',
      name: 'test',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/test/test'))),
    },
    {
      path: '/map',
      name: 'map',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/test/map'))),
    },
    {
      path: '/back',
      name: 'back',
      redirect: '/indexEditor',
      component: '',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/back/back'))),
      children: [
        { 
          path: '/indexEditor', // 首页
          name: 'indexEditor',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/indexEditor'
          )))
        },
        { 
          path: '/heatEditor', // 智慧供热
          name: 'heatEditor',
          meta: {
            requireAuth: true,  
          },
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/heatEditor'
          )))
        },
        { 
          path: '/heatAddRecord', // 智慧供热核心系统新增记录
          name: 'heatAddRecord',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/heatAddRecord'
          )))    
        },
        { 
          path: '/codeEditor', // 智慧空冷
          name: 'codeEditor',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/codeEditor'
          )))
        },
        { 
          path: '/energyEditor', // 能效云
          name: 'energyEditor',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/energyEditor'
          )))
        },
        { 
          path: '/propertyEditor', // 云城智慧平台
          name: 'propertyEditor',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/propertyEditor'
          )))
        },
        { 
          path: '/jobList', // 职位列表
          name: 'jobList',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/jobList'
          )))
        },
        {
          path: '/newsList', // 新闻列表
          name: 'newsList',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/newsList'
          )))
        },
        {
          path: '/newseditor', // 新闻编辑页面
          name: 'newseditor',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/newseditor'
          )))
        },
        {
          path: '/jobDetails', // 职位编辑页面
          name: 'jobDetails',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/jobDetails'
          )))
        },
        { 
          path: '/aboutUs', // 关于我们
          name: 'aboutUs',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/aboutUs'
          )))
        },
        { 
          path: '/imformationRelease', // 关于我们-信息发布
          name: 'imformationRelease',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/imformationRelease'
          )))
        },
        { 
          path: '/intention', // 关于我们-意向信息
          name: 'intention',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/intention'
          )))
        },
        { 
          path: '/applyUse', // 申请试用
          name: 'applyUse',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/applyUse'
          )))
        },
        { 
          path: '/mapEditor', // 世界地图
          name: 'mapEditor',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/mapEditor'
          )))
        },
        { 
          path: '/worldPointAdd', // 世界地图
          name: 'worldPointAdd',
          component: resolve => require.ensure([], () => resolve(require(
            '@/view/back/worldPointAdd'
          )))
        },
      ],
    },
    { 
      path: '/reload', // reload
      name: 'reload',
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/back/reload'
      )))
    },
    {
      path: '/recruit',
      name: 'recruit',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/recruit/index'))),
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/about/about.vue'))),
    },
    {
      path: '/contactUs',
      name: 'contactUs',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/contactUs/contactUs.vue'))),
    },
    {
      path: '/pHot',
      name: 'pHot',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/product/product-hot')))

    },
    {
      path: '/pPower',
      name: 'pPower',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/product/product-power')))
    },
    {
      path: '/pCold',
      name: 'pCold',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/product/product-cold')))
    },
    {
      path: '/pProper',
      name: 'pProper',
      meta: {
        auth: ['log.query']
      },
      component: resolve => require.ensure([], () => resolve(require(
        '@/view/product/product-proper')))
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js